import { useState } from 'react';
import { Eye, EyeSlash, LockKey } from '@phosphor-icons/react';

type PasswordFieldProps = {
  autoComplete: 'current-password' | 'new-password';
  label: string;
  hideLabel: string;
  showLabel: string;
  value: string;
  onChange: (value: string) => void;
};

export default function PasswordField({
  autoComplete,
  label,
  hideLabel,
  showLabel,
  value,
  onChange,
}: PasswordFieldProps) {
  const [visible, setVisible] = useState(false);

  return (
    <label>
      {label}
      <div className="input-icon password-input">
        <LockKey />
        <input
          autoComplete={autoComplete}
          minLength={6}
          required
          type={visible ? 'text' : 'password'}
          value={value}
          onChange={(event: any) => onChange(event.target.value)}
        />
        <button
          type="button"
          onClick={() => setVisible((current) => !current)}
          aria-label={visible ? hideLabel : showLabel}
        >
          {visible ? <EyeSlash /> : <Eye />}
        </button>
      </div>
    </label>
  );
}
